var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (BemEntity, JSON, article, articlePlaceholder, backgroundImage, classSuffixer, initial, isDesktop, mixHelpers, mixes, modalClassName, modalHasBackdrop, modalHasCloseButton, modalHasHeader, modalTitle, prettyPath, recBatchId, recId, recommended, state, time, urlDataBody, user) {const modalClassSuffixer = classSuffixer(modalClassName)
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([modalClassSuffixer('wrapper')], [true]), false, true)) + "\u003E";
if (modalHasBackdrop) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([modalClassSuffixer('backdrop')], [true]), false, true)) + "\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([modalClassSuffixer('content')], [true]), false, true)) + "\u003E";
if (modalHasHeader) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([modalClassSuffixer('header')], [true]), false, true)) + "\u003E\u003Cdiv" + (pug.attr("class", pug.classes([modalClassSuffixer('title')], [true]), false, true)) + "\u003E" + (pug.escape(null == (pug_interp = modalTitle) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
if (modalHasCloseButton) {
pug_html = pug_html + "\u003Cbutton" + (pug.attr("class", pug.classes([modalClassSuffixer('close-button')], [true]), false, true)) + "\u003E\u003Ci class=\"mdi-navigation-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([modalClassSuffixer('body')], [true]), false, true)) + "\u003E";
if (state === 'loading') {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["folding-animation",modalClassSuffixer('loading-animation')], [false,true]), false, true)) + "\u003E\u003C\u002Fdiv\u003E";
}
else
if (state === 'error') {
pug_html = pug_html + (null == (pug_interp = require("../partials/mix-select-error.pug").call(this, locals)) ? "" : pug_interp);
}
else {
pug_mixins["article-image"] = pug_interp = function(article){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "article-image","style": pug.escape(pug.style(backgroundImage([
      article.md5image,
      article.image,
      articlePlaceholder
    ])))},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["article-info"] = pug_interp = function(article){
var block = (this && this.block), attributes = (this && this.attributes) || {};
const articleDomainPath = '/search/' + article.hostname + '/domain'

pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "article-info"},attributes]), true)) + "\u003E\u003Ca" + (" class=\"article-domain\""+pug.attr("title", article.hostname, true, true)+pug.attr("href", articleDomainPath, true, true)+" rel=\"nofollow\"") + "\u003E" + (pug.escape(null == (pug_interp = article.hostname) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003Ca" + (" class=\"article-title\""+" data-click=\"open-website\""+pug.attr("href", article.url, true, true)+" rel=\"nofollow\"") + "\u003E" + (pug.escape(null == (pug_interp = article.title) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["article-mix-button"] = pug_interp = function(article){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (user.loggedIn) {
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["mix-button","waves-effect","waves-light",{'has-mix': article.hasMix}], [false,false,false,true]),"data-url-id": pug.escape(article.url_id),"data-click": "select-mix,track-click","data-track-event": "remix-tile-click"},attributes]), true)) + "\u003E";
if (article.hasMix) {
pug_html = pug_html + "\u003Ci class=\"mdi-action-bookmark mdi-action-bookmark-outline\"\u003E\u003C\u002Fi\u003EAdded";
}
else {
pug_html = pug_html + "\u003Ci class=\"mdi-action-bookmark-outline\"\u003E\u003C\u002Fi\u003EAdd";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "mix-button waves-effect waves-light","data-url-id": pug.escape(article.url_id),"data-click": "auth-login-modal"},attributes]), true)) + "\u003E\u003Ci class=\"mdi-action-bookmark-outline\"\u003E\u003C\u002Fi\u003EAdd\u003C\u002Fdiv\u003E";
}
};
pug_mixins["article-card"] = pug_interp = function(article){
var block = (this && this.block), attributes = (this && this.attributes) || {};
const bem = BemEntity('article-card')
const cardTitle = article.title + '\nFrom ' + article.hostname
const articlePath = prettyPath(article.hash, article.title)
const articleDataBody = JSON.stringify(urlDataBody(article))
const articleImagePath = article.md5image || article.image
const articleHasVideoEmbed = isDesktop && !!article.video
const articleCount = article.count // TODO Rounding/shortening
let showPreviewClick = 'show-article-profile-modal'
if (user.loggedIn) {
  showPreviewClick = 'track-click,' + showPreviewClick
}

pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([bem.block()], [true]), false, true)+pug.attr("title", cardTitle, true, true)+pug.attr("data-timestamp", article.timestamp, true, true)+pug.attr("data-url-id", article.url_id, true, true)+pug.attr("data-body", articleDataBody, true, true)+pug.attr("data-image-url", articleImagePath, true, true)+pug.attr("data-rec-batch-id", recBatchId, true, true)+pug.attr("data-rec-id", recId, true, true)) + "\u003E\u003Cdiv" + (pug.attr("class", pug.classes([bem.element('inner', { 'has-video-embed': articleHasVideoEmbed })], [true]), false, true)) + "\u003E";
if (articleHasVideoEmbed) {
pug_mixins["article-image"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([bem.element('video')], [true]), false, true)) + "\u003E" + (null == (pug_interp = article.video) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
},
attributes: {"class": pug.classes([bem.element('image', ['top', 'video'])], [true])}
}, article);
}
pug_mixins["article-info"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([bem.element('info-buttons')], [true]), false, true)) + "\u003E\u003Ca" + (pug.attr("class", pug.classes([bem.element('preview-button')], [true]), false, true)+pug.attr("href", articlePath, true, true)+pug.attr("data-click", showPreviewClick, true, true)+" data-track-event=\"remix-tile-click\""+pug.attr("data-track-data", { url: article.url }, true, true)) + "\u003E\u003C\u002Fa\u003E";
if (user.loggedIn) {
pug_html = pug_html + "\u003Cbutton" + (pug.attr("class", pug.classes([bem.element('more-button')], [true]), false, true)+" data-click=\"article-actions-modal\"") + "\u003E\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (article.description) {
pug_html = pug_html + "\u003Ca" + (pug.attr("class", pug.classes([bem.element('description')], [true]), false, true)+pug.attr("href", article.url, true, true)+" data-click=\"open-website\" rel=\"nofollow\"") + "\u003E" + (pug.escape(null == (pug_interp = article.description) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
},
attributes: {"class": pug.classes([bem.element('info')], [true])}
}, article);
if (!articleHasVideoEmbed) {
pug_html = pug_html + "\u003Ca" + (pug.attr("class", pug.classes([bem.element('image-href')], [true]), false, true)+pug.attr("href", article.url, true, true)+" data-click=\"open-website\" rel=\"nofollow\"") + "\u003E";
pug_mixins["article-image"].call({
attributes: {"class": pug.classes([bem.element('image', 'bottom')], [true])}
}, article);
pug_html = pug_html + "\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([bem.element('footer')], [true]), false, true)) + "\u003E\u003C\u002Fdiv\u003E";
if (articleCount) {
pug_html = pug_html + "\u003Ca" + (pug.attr("class", pug.classes([bem.element('count')], [true]), false, true)+pug.attr("href", articlePath, true, true)+pug.attr("data-click", showPreviewClick, true, true)+" data-track-event=\"remix-tile-click\""+pug.attr("data-track-data", { url: article.url }, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = articleCount) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
pug_mixins["article-mix-button"].call({
attributes: {"class": pug.classes([bem.element('mix-button')], [true])}
}, article);
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};













pug_mixins["follow-button-logged-out"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cbutton" + (pug.attrs(pug.merge([{"class": "follow-button","data-click": "auth-login-modal,stop-propagation"},attributes]), true)) + "\u003E+ Follow\u003C\u002Fbutton\u003E";
};
pug_mixins["follow-button-minimal-logged-out"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cbutton" + (pug.attrs(pug.merge([{"class": "minimal follow-button","data-click": "auth-login-modal,stop-propagation"},attributes]), true)) + "\u003E\u003Ci class=\"mdi-content-add\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E";
};


































































pug_mixins["mix-list-item"] = pug_interp = function(mix, isRecommended){
var block = (this && this.block), attributes = (this && this.attributes) || {};
const userPath = mix.username && '/' + mix.username
const mixPath = mix.id && userPath + '/' + mix.slug
const mixTitle = mixHelpers.formatMixName(mix)
const modifiedAgo = mix.modified_at && time.ago(mix.modified_at)

pug_html = pug_html + "\u003Cli" + (pug.attrs(pug.merge([{"class": "mix-list-item","data-mix-id": pug.escape(mix.id),"data-mix-name": pug.escape(mixTitle),"data-mix-slug": pug.escape(mix.slug),"data-mix-owner": pug.escape(mix.username),"data-recommended": pug.escape(isRecommended),"data-mixed": pug.escape(mix.isMixed)},attributes]), true)) + "\u003E\u003Cdiv" + (" class=\"mix-list-item__thumb\""+pug.attr("href", mixPath, true, true)+pug.attr("data-navigate", mixPath, true, true)+pug.attr("style", pug.style(backgroundImage([
        mix.images && mix.images[0],
        articlePlaceholder
      ])), true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"mix-list-item__info\"\u003E\u003Ca" + (" class=\"mix-list-item__name\""+pug.attr("href", mixPath, true, true)+pug.attr("data-navigate", mixPath, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = mixTitle) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
if (!mix.id && isRecommended) {
pug_html = pug_html + "\u003Cdiv class=\"mix-list-item__subtitle\"\u003ESuggested\u003C\u002Fdiv\u003E";
}
else
if (modifiedAgo) {
pug_html = pug_html + "\u003Cdiv class=\"mix-list-item__subtitle\"\u003ELast updated" + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp)) + (pug.escape(null == (pug_interp = modifiedAgo) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"mix-list-item__actions\"\u003E\u003Ca class=\"minimal mix-follow-button following-button\"\u003E\u003Ci class=\"mdi-navigation-check\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003Cdiv class=\"mix-list-item__spinner\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E";
};
const bem = BemEntity('mix-select')
const MAX_COLLECTION_NAME_LENGTH = 50
const MAX_COMMENT_TEXT_LENGTH = 10000

pug_html = pug_html + "\u003Cform" + (pug.attr("class", pug.classes([bem.element('form')], [true]), false, true)+pug.attr("data-body", article, true, true)+pug.attr("data-rec-id", recId, true, true)+pug.attr("data-rec-batch-id", recBatchId, true, true)) + "\u003E\u003Cdiv" + (pug.attr("class", pug.classes([bem.element('article')], [true]), false, true)) + "\u003E";
pug_mixins["article-image"].call({
attributes: {"class": pug.classes([bem.element('article-image')], [true])}
}, article);
pug_mixins["article-info"].call({
attributes: {"class": pug.classes([bem.element('article-info')], [true])}
}, article);
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv" + (pug.attr("class", pug.classes([bem.element('field')], [true]), false, true)) + "\u003E\u003Cinput" + (pug.attr("class", pug.classes([bem.element('input')], [true]), false, true)+" tabindex=\"1\" type=\"text\" placeholder=\"Type a name (e.g. &quot;Places I Love&quot;) or select one below\""+pug.attr("maxlength", MAX_COLLECTION_NAME_LENGTH, true, true)+" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" autofocus") + "\u003E\u003Cbutton" + (pug.attr("class", pug.classes([bem.element('create', 'hidden')], [true]), false, true)) + "\u003ECreate\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cul" + (pug.attr("class", pug.classes([bem.element('list')], [true]), false, true)) + "\u003E";
if (initial) {
pug_mixins["mix-list-item"](initial, initial.recommended);
}
// iterate recommended
;(function(){
  var $$obj = recommended;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var mix = $$obj[pug_index1];
pug_mixins["mix-list-item"](mix, true);
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var mix = $$obj[pug_index1];
pug_mixins["mix-list-item"](mix, true);
    }
  }
}).call(this);

// iterate mixes
;(function(){
  var $$obj = mixes;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var mix = $$obj[pug_index2];
pug_mixins["mix-list-item"](mix, false);
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var mix = $$obj[pug_index2];
pug_mixins["mix-list-item"](mix, false);
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E\u003Cdiv" + (pug.attr("class", pug.classes([bem.element('comment')], [true]), false, true)) + "\u003E\u003Ctextarea" + (pug.attr("class", pug.classes(["materialize-textarea",bem.element('comment-textarea')], [false,true]), false, true)+" tabindex=\"2\""+pug.attr("maxlength", MAX_COMMENT_TEXT_LENGTH, true, true)+" placeholder=\"Add a public comment about this page\"") + "\u003E\u003C\u002Ftextarea\u003E\u003Cbutton" + (pug.attr("class", pug.classes([bem.element('comment-submit')], [true]), false, true)) + "\u003EPost\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cbutton" + (pug.attr("class", pug.classes([bem.element('dismiss')], [true]), false, true)) + "\u003EDone\u003C\u002Fbutton\u003E\u003C\u002Fform\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"BemEntity" in locals_for_with?locals_for_with.BemEntity:typeof BemEntity!=="undefined"?BemEntity:undefined,"JSON" in locals_for_with?locals_for_with.JSON:typeof JSON!=="undefined"?JSON:undefined,"article" in locals_for_with?locals_for_with.article:typeof article!=="undefined"?article:undefined,"articlePlaceholder" in locals_for_with?locals_for_with.articlePlaceholder:typeof articlePlaceholder!=="undefined"?articlePlaceholder:undefined,"backgroundImage" in locals_for_with?locals_for_with.backgroundImage:typeof backgroundImage!=="undefined"?backgroundImage:undefined,"classSuffixer" in locals_for_with?locals_for_with.classSuffixer:typeof classSuffixer!=="undefined"?classSuffixer:undefined,"initial" in locals_for_with?locals_for_with.initial:typeof initial!=="undefined"?initial:undefined,"isDesktop" in locals_for_with?locals_for_with.isDesktop:typeof isDesktop!=="undefined"?isDesktop:undefined,"mixHelpers" in locals_for_with?locals_for_with.mixHelpers:typeof mixHelpers!=="undefined"?mixHelpers:undefined,"mixes" in locals_for_with?locals_for_with.mixes:typeof mixes!=="undefined"?mixes:undefined,"modalClassName" in locals_for_with?locals_for_with.modalClassName:typeof modalClassName!=="undefined"?modalClassName:undefined,"modalHasBackdrop" in locals_for_with?locals_for_with.modalHasBackdrop:typeof modalHasBackdrop!=="undefined"?modalHasBackdrop:undefined,"modalHasCloseButton" in locals_for_with?locals_for_with.modalHasCloseButton:typeof modalHasCloseButton!=="undefined"?modalHasCloseButton:undefined,"modalHasHeader" in locals_for_with?locals_for_with.modalHasHeader:typeof modalHasHeader!=="undefined"?modalHasHeader:undefined,"modalTitle" in locals_for_with?locals_for_with.modalTitle:typeof modalTitle!=="undefined"?modalTitle:undefined,"prettyPath" in locals_for_with?locals_for_with.prettyPath:typeof prettyPath!=="undefined"?prettyPath:undefined,"recBatchId" in locals_for_with?locals_for_with.recBatchId:typeof recBatchId!=="undefined"?recBatchId:undefined,"recId" in locals_for_with?locals_for_with.recId:typeof recId!=="undefined"?recId:undefined,"recommended" in locals_for_with?locals_for_with.recommended:typeof recommended!=="undefined"?recommended:undefined,"state" in locals_for_with?locals_for_with.state:typeof state!=="undefined"?state:undefined,"time" in locals_for_with?locals_for_with.time:typeof time!=="undefined"?time:undefined,"urlDataBody" in locals_for_with?locals_for_with.urlDataBody:typeof urlDataBody!=="undefined"?urlDataBody:undefined,"user" in locals_for_with?locals_for_with.user:typeof user!=="undefined"?user:undefined));;return pug_html;};
module.exports = template;